import { render, staticRenderFns } from "./info-tooltip.vue?vue&type=template&id=a6370c52&lang=pug"
import script from "./info-tooltip.vue?vue&type=script&lang=ts"
export * from "./info-tooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports